import React, { useEffect, useRef, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";

export default function TenantContact() {
  const [msgs, setMsgs] = useState(null);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);

  const load = () => api.get("/tenant/messages").then(({ data }) => setMsgs(data)).catch(() => setMsgs([]));
  useEffect(() => { load(); }, []);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try {
      await api.post("/tenant/messages", { text });
      setText(""); await load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  if (msgs === null) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>;

  return (
    <div data-testid="tenant-contact" className="flex flex-col h-[70vh]">
      <h1 className="font-display text-2xl font-light mb-4">お問い合わせ</h1>
      <div className="flex-1 overflow-y-auto bg-[#161616] border border-white/5 rounded-lg p-4 space-y-3">
        {msgs.length === 0 && <div className="text-gray-500 text-sm text-center py-10">管理会社へのメッセージをお送りいただけます。</div>}
        {msgs.map((m) => (
          <div key={m.id} className={`flex ${m.sender === "tenant" ? "justify-end" : "justify-start"}`} data-testid={`msg-${m.id}`}>
            <div className={`max-w-[75%] rounded-lg px-3 py-2 text-sm ${m.sender === "tenant" ? "bg-brand text-white" : "bg-[#232323] text-gray-200"}`}>
              <div className="whitespace-pre-wrap break-words">{m.text}</div>
              <div className="text-[10px] opacity-60 mt-1">{(m.created_at || "").slice(0, 16).replace("T", " ")}</div>
            </div>
          </div>
        ))}
        <div ref={endRef} />
      </div>
      <form onSubmit={send} className="mt-3 flex gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="メッセージを入力..."
          className="flex-1 bg-[#0d0d0d] border border-white/10 rounded-md px-4 py-2.5 text-white text-sm focus:outline-none focus:border-brand" data-testid="contact-input" />
        <button type="submit" disabled={busy} className="bg-brand hover:bg-brand-hover text-white px-4 rounded-md inline-flex items-center" data-testid="contact-send">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
        </button>
      </form>
    </div>
  );
}
